<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Broker Score</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="activeTab" class="tab-container mb-4" color="primary">
        <v-tab value="overall">Overall</v-tab>
        <v-tab key="invite">Invites</v-tab>
        <v-tab value="updates">Updates</v-tab>
        <v-tab value="metwith">Met With</v-tab>
        <v-tab value="conversion">Conversion</v-tab>
      </v-tabs>
      <v-window v-model="activeTab" style="background-color: unset">
        <!-- Overall -->
        <v-window-item value="overall">
          <v-col class="align-center">
            <overview-broker-score-chart :chart.sync="overallChartData" />
          </v-col>
        </v-window-item>
        <!--           Invite -->
        <v-window-item key="invites">
          <v-col class="align-center">
            <overview-broker-score-chart :chart.sync="invitesChartData">
              ></overview-broker-score-chart
            >
          </v-col>
        </v-window-item>
        <!-- Updates -->
        <v-window-item value="updates">
          <v-col class="chart-container align-center">
            <overview-broker-score-chart :chart.sync="updatesChartData">
              ></overview-broker-score-chart
            >
          </v-col>
        </v-window-item>
        <!-- Metwith -->
        <v-window-item value="metwith">
          <v-col class="chart-container align-center">
            <overview-broker-score-chart :chart.sync="metwithChartData" />
          </v-col>
        </v-window-item>
        <!-- Conversion -->
        <v-window-item value="conversion">
          <v-col class="chart-container align-center">
            <overview-broker-score-chart :chart.sync="conversionChartData" />
          </v-col>
        </v-window-item>
      </v-window>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import OverviewBrokerScoreChart from "@/components/console/dashboard/OverviewBrokerScoreChart";

export default {
  name: "OverviewBrokerScore",
  components: {
    OverviewBrokerScoreChart,
  },
  props: {},
  watch: {},
  data() {
    return {
      psGreen: "#00C8A8",
      platinum: "#8F99A0",
      gold: "#E3CD61",
      silver: "#A9B1B3",
      bronze: "#AD8A56",
      redZone: "#AF322F",
      activeTab: null,
      statData: {},
      loading: false,
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
    brokerScores() {
      let overallScore = null;
      let invitesScore = null;
      let updatesScore = null;
      let metwithScore = null;
      let conversionScore = null;

      if (this.impBrokerage) {
        console.log("Impersonated Brokerage scores below:");
        console.log(this.impBrokerage.brokerScore);
        console.log(this.impBrokerage.percentInvitesEngaged30Days);
        console.log(this.impBrokerage.upToDatePercent);
        console.log(this.impBrokerage.metWithRate90Day);
        console.log(this.impBrokerage.projectedConversion12Mo);
        overallScore = this.impBrokerage.brokerScore;
        invitesScore = this.impBrokerage.percentInvitesEngaged30Days;
        updatesScore = this.impBrokerage.upToDatePercent;
        metwithScore = this.impBrokerage.metWithRate90Day;
        conversionScore = this.impBrokerage.projectedConversion12Mo;
      } else if (this.myBrokerage) {
        overallScore = this.myBrokerage.brokerScore;
        invitesScore = this.myBrokerage.percentInvitesEngaged30Days;
        updatesScore = this.myBrokerage.upToDatePercent;
        metwithScore = this.myBrokerage.metWithRate90Day;
        conversionScore = this.myBrokerage.projectedConversion12Mo;
      }
      return {
        brokerScore: overallScore,
        percentInvitesEngaged30Days: invitesScore,
        upToDatePercent: updatesScore,
        metWithRate90Day: metwithScore,
        projectedConversion12Mo: conversionScore,
      };
    },
    overallChartData() {
      let score = this.brokerScores.brokerScore * 100;
      let percentage = Math.round(score / 2); // divide score by 2 due to showing half pie chart
      let type = "Overall Performance";
      // let displayScore = this.formatToFixed(score, 2);
      let displayScore = Math.trunc(score);
      let legendText = this.levelData(score).text;
      let color = this.levelData(score).color;
      return {
        legendText: legendText,
        displayScore: displayScore,
        percentage: percentage,
        type: type,
        color: color,
        isNullScore: !this.brokerScores.brokerScore,
      };
    },
    invitesChartData() {
      let score = this.brokerScores.percentInvitesEngaged30Days * 100;
      let percentage = Math.round(score / 2); // divide score by 2 due to showing half pie chart
      let type = "Invites Performance";
      // let displayScore = this.formatToFixed(score, 2);
      let displayScore = Math.trunc(score);
      let legendText = this.levelData(score).text;
      let color = this.levelData(score).color;
      return {
        legendText: legendText,
        displayScore: displayScore,
        percentage: percentage,
        type: type,
        color: color,
        isNullScore: !this.brokerScores.percentInvitesEngaged30Days,
      };
    },
    updatesChartData() {
      let score = this.brokerScores.upToDatePercent * 100;
      let percentage = Math.round(score / 2); // divide score by 2 due to showing half pie chart
      let type = "Updates Performance";
      // let displayScore = this.formatToFixed(score, 2);
      let displayScore = Math.trunc(score);
      let legendText = this.levelData(score).text;
      let color = this.levelData(score).color;
      return {
        legendText: legendText,
        displayScore: displayScore,
        percentage: percentage,
        type: type,
        color: color,
        isNullScore: !this.brokerScores.upToDatePercent,
      };
    },
    metwithChartData() {
      let score = this.brokerScores.metWithRate90Day * 100;
      let percentage = Math.round(score / 2); // divide score by 2 due to showing half pie chart
      let type = "Met With Performance";
      // let displayScore = this.formatToFixed(score, 2);
      let displayScore = Math.trunc(score);
      let legendText = this.levelData(score).text;
      let color = this.levelData(score).color;
      return {
        legendText: legendText,
        displayScore: displayScore,
        percentage: percentage,
        type: type,
        color: color,
        isNullScore: !this.brokerScores.metWithRate90Day,
      };
    },
    conversionChartData() {
      let score = this.brokerScores.projectedConversion12Mo * 100;
      // score = 5 // testing fore ease 5 = 50% of 10%
      let percentageOffset = score <= 10 ? 10 : score <= 35 ? 35 : 100; // offset percentage this chart is not 100% - 10% or 35%
      let percentage = (score / percentageOffset) * 100; // new score percentage after the offset
      percentage = Math.round(percentage / 2); // divide score by 2 due to showing half pie chart
      let type = "Conversion Performance";
      // now only conversion will have 2 decimals - the rest of tabs will be whole number.
      let displayScore = this.formatToFixed(score, 2);
      let legendText = this.conversionLevelData(score).text;
      let color = this.conversionLevelData(score).color;
      return {
        legendText: legendText,
        displayScore: displayScore,
        percentage: percentage,
        type: type,
        color: color,
        isNullScore: !this.brokerScores.projectedConversion12Mo,
      };
    },
  },
  methods: {
    formatToFixed(num, fixed) {
      // this is needed due to a precision bug with toFixed()
      const re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
      return num.toString().match(re)[0];
    },
    levelData(displayScore) {
      let color = this.psGreen;
      let text = "";
      switch (true) {
        case displayScore < 50:
          color = this.redZone;
          text = "Red: Less than 50%";
          break;
        case displayScore >= 50 && displayScore < 65:
          color = this.bronze;
          text = "Bronze: 50 - 65%";
          break;
        case displayScore >= 65 && displayScore < 80:
          color = this.silver;
          text = "Silver: 65 - 80%";
          break;
        case displayScore >= 80 && displayScore < 90:
          color = this.gold;
          text = "Gold: 80 - 90%";
          break;
        case displayScore >= 90 && displayScore <= 100:
          color = this.platinum;
          text = "Platinum: 90 - 100%";
          break;
      }
      return {
        color: color,
        text: text,
      };
    },
    conversionLevelData(displayScore) {
      let color = this.psGreen;
      let text = "";
      switch (true) {
        case displayScore < 0.75:
          color = this.redZone;
          text = "Red: Less than .75%";
          break;
        case displayScore >= 0.75 && displayScore < 1.5:
          color = this.bronze;
          text = "Bronze: .75 - 1.5%";
          break;
        case displayScore >= 1.5 && displayScore < 2.25:
          color = this.silver;
          text = "Silver: 1.5 - 2.25%";
          break;
        case displayScore >= 2.25 && displayScore < 3.0:
          color = this.gold;
          text = "Gold: 2.25 - 3%";
          break;
        case displayScore >= 3.0:
          color = this.platinum;
          text = "Platinum: 3% and up";
          break;
      }
      return {
        color: color,
        text: text,
      };
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewBrokerScoreToolTip");
    },
  },
  mounted() {
    console.log("Mounted broker score");
  },
};
</script>

<style scoped>
/*See ConsoleOverview for non-scoped classes*/

.tab-container >>> .v-tab {
  font-size: 14px;
  text-transform: none;
  min-width: unset;
  letter-spacing: unset;
  /*padding: 0 8px;*/
}
.tab-container >>> .v-slide-group__prev {
  /*display: none !important;*/
  visibility: unset !important;
}

/*.progress-container {*/
/*  width: 100%;*/
/*  min-height: 420px;*/
/*  display: flex;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*}*/

.chart-container {
  padding-top: 48px;
  position: relative;
}
</style>
